export const MaintenanceType =
{
    Repair: 0,
    Replace: 1,
    Service: 2
};

export const MaintenanceStatus =
{
    Initiated: 0,
    Approved: 1,
    Pending: 2,
    Declined: 3,
    Cancel: 4
};